import Tone from 'tone';
import {recordAutomation} from 'operations/actions.js';
import {setEffectParameterValue} from 'actions/index.js';

export default superclass => class extends superclass  {
    callSetter() {
        let value = this.get();
        this.setter(this.object, value);
    }

    set(x, automation=true, isBulk=false, time, rampTime=0.040, isPLock) {
        if (this.immutable) {
            // if a parameter is immmutable don't do anything
            return {};
        }

        if (this.builder) {
            x = this.builder(x);
        }
        let oldValue = this.value;
        if (automation && !isPLock) {
            this.automatedValue = x;
        } else {
            this.value = x;
        }

        if (time && (this.audioParam || this.audioParams) && !isNaN(x)) {
            let audioParams = this.audioParams ? this.audioParams : [this.audioParam];
            let _value = x;
            if (this.name === 'macro' || this.name === 'BPM' || this.name === 'send volume') {
                if (this.name === 'BPM') {
                    //this.audioParam.value = _value;
                    this.sequencerEngine.onNewBpm(_value);
                } else {
                    this.audioParam.setValueAtTime(_value, time);
                }
            } else if (audioParams.every(x => x.linearRampTo)) {
                audioParams.forEach(
                    param => 
                        param.linearRampTo(_value, rampTime, time));
            } else {
                audioParams.forEach(
                    param => param.linearRampToValueAtTime ? param.linearRampToValueAtTime(
                        _value, time + rampTime) : 0);
            }
        } else {
            if (time) {
                let timeoutTime = time - Tone.Master.context.now();
                Tone.Master.context.setTimeout(() => {
                    this.setter(this.object, x, automation, time);
                }, timeoutTime);
            } else {
                this.setter(this.object, x, automation, time);
            }
        }

        if (this.store !== undefined) {
            if (this.track && this.track.preset && this.isLoaded) {
                this.track.preset.hasEdits = true;
            }

            if (!isBulk) {
                this.store.dispatch(setEffectParameterValue(this.id, this.value));
            } 
            if (!automation && (this.isRecording || this.isRecordingMix)) {
                // then we need to record into the automation
                let _automation = this.isRecordingMix ? this.mixAutomation : this.automation;
                if (this.sequencerEngine) {
                    this.sequencerEngine.operationManager.dispatch(
                        recordAutomation(
                            this,
                            _automation,
                            this.value,
                            oldValue));
                }  else {
                    _automation.record(this.value, oldValue);
                }
            }
        }

        if (this.isMapped && !automation) {
            let accumulator = this.isMapped;
            accumulator.clearParameter(this);
        }

        if (this.config.onChange) {
            this.config.onChange(x);
        }

        return {
            id: this.id,
            value: this.value
        };
   }

    set value(val) {
        // check if locked
        if (this.isPaletteLocked(true)) {
            this.paletteToValue[this.getCurrentPalette(true)] = val;
        } else if (this.hasStepsSelected()) {
            this.setPLockedValue(val);
        } else if (this.isPatternLocked()) {
            this.patternToValue[this.currentPattern] = val;
        } else {
            this.unlockedValue = val;
        }
    }

    get value() {
        if (this.hasStepsSelected(false)) {
            if (Object.keys(this.stepToValue).length > 0) {
                let step = this.selectedSteps.find(
                    ({id}) => id in this.stepToValue);
                if (step) {
                    return this.stepToValue[step.id];
                }
            }
        }
        if (this.isPaletteLocked()) {
            return this.getPaletteValue(this.getCurrentPalette());
        } else if (this.isPatternLocked()) {
            let currentPattern = this.currentPattern;
            if (currentPattern === undefined) {
                return undefined;
            }
            
            let v = this.patternToValue[currentPattern];
            if (v === undefined) {
                return this.unlockedValue;
            }
            return v;
        } else {
            return this.unlockedValue;
        }
    }

    /**
     * sets the parameter with a variable from 0 to 1
     */
    normalizedSet(x, automation=false, isBulk=false, time) {
        this.set(this.normalize(x), automation, isBulk, time);
    }

    normalizeOriginal(x) {
        return this.originalMin + (this.originalMax - this.originalMin) * x
    }

    normalize(x) {
        return this.min + (this.max - this.min) * x
    }

    // called when switch to pattern happens
    updateRedux(isBulk=false, time) {
        // clear all patternToAutomations
        for (let i in this.patternToAutomation) {
            this.patternToAutomation[i].clear();
        }

        // TODO: need to clear the old automation and
        // schedule the new, for the remainder of the beat
        if (this.unlockedAutomation) {
            this.unlockedAutomation.clear();
        }
        if (this.automation) {
            this.automation.clear();
            this.automation.store = this.store;

            // TODO: this needs to be bulk updated for christ sake
            this.automation.updateRedux();
        }

        if (this.mixAutomation) {
            this.mixAutomation.store = this.store;
        }

 
        if (this.value !== null && this.value !== undefined) {
            return this.set(this.value, true, isBulk, time);
        }
    }

    refresh(force=true, isBulk=false, time, isPLock) {
        let v = this.get(force);
        if (v !== null && v !== undefined) {
            return this.set(this.get(force), true, isBulk, time, undefined, isPLock);
        }
        return undefined;
    }
}
